"use client";

import type { Stimulus } from "@/lib/exams/toefl/stimulus";

// Presentational view of the active TOEFL stimulus. For Integrated it shows the
// reading passage and the lecture transcript in two labelled panels (the
// transcript framed as "what you would hear"). For Discussion it shows the
// professor's question then the two student posts styled as a discussion board.
// Plain Tailwind, matching the indigo card styling of the mark page — no chart.
export function ToeflStimulusView({ stimulus }: { stimulus: Stimulus }) {
  if (stimulus.task === "integrated") {
    return (
      <div className="space-y-3">
        {stimulus.readingPassage && (
          <div className="rounded-xl border border-brand-soft bg-brand-surface p-4">
            <p className="mb-2 text-xs font-semibold tracking-wide text-brand uppercase">
              Reading passage
            </p>
            <p className="text-sm leading-relaxed whitespace-pre-line text-gray-700">
              {stimulus.readingPassage}
            </p>
          </div>
        )}
        {stimulus.lectureTranscript && (
          <div className="rounded-xl border border-brand-soft bg-brand-surface p-4">
            <p className="mb-2 text-xs font-semibold tracking-wide text-brand uppercase">
              Lecture (what you would hear)
            </p>
            <p className="text-sm leading-relaxed whitespace-pre-line text-gray-700">
              {stimulus.lectureTranscript}
            </p>
          </div>
        )}
      </div>
    );
  }

  return (
    <div className="space-y-3">
      {stimulus.professorPrompt && (
        <div className="rounded-xl border border-brand-soft bg-brand-surface p-4">
          <p className="mb-2 text-xs font-semibold tracking-wide text-brand uppercase">
            Your professor
          </p>
          <p className="text-sm leading-relaxed whitespace-pre-line text-gray-700">
            {stimulus.professorPrompt}
          </p>
        </div>
      )}
      {stimulus.studentPosts && stimulus.studentPosts.length > 0 && (
        <div className="space-y-3 rounded-xl border border-gray-200 bg-white p-4">
          <p className="text-xs font-semibold tracking-wide text-gray-500 uppercase">
            Discussion board
          </p>
          {stimulus.studentPosts.map((post, i) => (
            <div key={i} className="border-l-2 border-brand-soft pl-3">
              <p className="text-sm font-semibold text-brand">{post.author}</p>
              <p className="mt-0.5 text-sm leading-relaxed text-gray-700">{post.text}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
